import React from "react";
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Typography
} from "@mui/material";

interface TableRowItemProps {
  label: string;
  data: Record<string, string | number | null>;
}

export const Title = ({
  label,
  subTitle = false
}: {
  label: string;
  subTitle?: boolean;
}): React.ReactNode => (
  <Typography
    style={{ paddingLeft: `${subTitle ? "16px" : ""}` }}
    fontWeight={`${subTitle ? "500" : "600"}`}
  >
    {label}
  </Typography>
);

const TableRowItem: React.FC<TableRowItemProps> = ({ data, label }) => {
  const values = Object.values(data).filter((item) => item !== null && item !== "");

  if (values.length === 0) return null;

  return (
    <TableRow
      sx={{
        "&:last-child td, &:last-child th": { borderBottom: 0 }
      }}
    >
      <TableCell
        sx={{
          fontWeight: "bold",
          textAlign: "center",
          borderRight: "1px solid",
          borderColor: "divider"
        }}
      >
        {label}
      </TableCell>

      {Object.keys(data).map((col, i, arr) => (
        <TableCell
          key={col}
          sx={{
            fontWeight: 500,
            textAlign: "center",
            borderRight: i === arr.length - 1 ? "none" : "1px solid",
            borderColor: "divider"
          }}
        >
          {data[col] === null || data[col] === "" ? "-" : data[col]}
        </TableCell>
      ))}
    </TableRow>
  );
};

interface TableViewProps {
  data: Record<string, Record<string, string | number | null>>;
  headers: string[];
}

const EyeTableView: React.FC<TableViewProps> = ({ data, headers }) => (
  <TableContainer
    component={Paper}
    sx={{
      mt: 0.5,
      boxShadow: "none",
      border: "1px solid",
      borderColor: "divider",
      borderRadius: 1,
      overflow: "hidden"
    }}
  >
    <Table
      size="small"
      sx={{
        borderCollapse: "collapse",
        "& th, & td": {
          borderBottom: "1px solid",
          borderColor: "divider"
        }
      }}
    >
      <TableHead>
        <TableRow>
          <TableCell
            sx={{
              borderRight: "1px solid",
              borderColor: "divider"
            }}
          />

          {headers.slice(1).map((header, i) => (
            <TableCell
              key={header}
              align="center"
              sx={{
                fontWeight: "bold",
                borderRight: i === headers.length - 2 ? "none" : "1px solid",
                borderColor: "divider"
              }}
            >
              {header}
            </TableCell>
          ))}
        </TableRow>
      </TableHead>

      <TableBody>
        {Object.keys(data).map((label) => (
          <TableRowItem key={label} label={label} data={data[label]} />
        ))}
      </TableBody>
    </Table>
  </TableContainer>
);

export default EyeTableView;
